// extracted by css-extract-rspack-plugin
var _1 = "content-bhoi5N";
var _2 = "empty-K2J9JW";
var _3 = "fields-tP71vl";
var _4 = "header-uyTxnH";
var _5 = "label-CGHF8I";
var _6 = "markdown-dch4ll";
var _7 = "panel-g6sHab";
var _8 = "title-Mq05wF";
var _9 = "value-fBFauf";
export { _1 as "content", _2 as "empty", _3 as "fields", _4 as "header", _5 as "label", _6 as "markdown", _7 as "panel", _8 as "title", _9 as "value" }
